import useCategoriesByCustomer from './useCategoriesByCustomer';

/**
 * Obtains a list of categories by company
 */
const useSelectedCustomerCategories = (allowRequest = true) => {
  const props = useCategoriesByCustomer({ allowRequest });
  return props;
};

export default useSelectedCustomerCategories;
